import * as ActionTypes from '@commonActionTypes'


// clear form 
export const clearForm=()=>{
    return{
        type:ActionTypes.CLEAR_FORM
    }
}
// initialize Header Form


export const initializeHeaderForm =(payload)=>{
    return {
        type: ActionTypes.INITIALIZE_HEADER_FORM,
        payload
    }
}
export const updateShipmentFieldValue=(payload)=> {
       
    return {
        type: ActionTypes.UPDATE_SHIPMENT_FIELD_VALUE,
        payload
    }
}





